<script setup lang="ts">
import { SolrParamsKey } from '#shared/solr'

const route = useRoute<'book-about-by-id'>()
const bookId = computed(() => route.params.bokId ?? '')

const { data: bookData, suspense: bookSuspense } = useSolrQueryV2(
  computed(() => ({ [SolrParamsKey.Id]: bookId.value, [SolrParamsKey.ContentType]: ['book'] })),
  'book',
  'literature',
)

await bookSuspense()

const book = computed(() => bookData.value?.response?.docs[0] ?? null)
const title = computed(() => book.value?.title ?? 'Faglitteratur')

const breadcrumbOverrides = computed(() => {
  const segments = route.path.split('/')
  return segments.map((_, i) => {
    if (i < 2) {
      return undefined
    }

    if (i === 2) {
      return false
    }

    if (i === 3) {
      return { label: title.value, to: `/faglitteratur/bok/${toValue(bookId)}` }
    }

    return { label: 'Om boken' }
  })
})

definePageMeta(({
  name: 'book-about-by-id',
  key: 'book-about-by-id',
  layout: 'default',
  colorMode: 'light',
  theme: 'carbon',
}))

useHead({
  title,
  bodyAttrs: {
    class: 'bg-white',
  },
})
</script>

<template>
  <div>
    <ContentDiv class="flex items-start">
      <Breadcrumbs :overrides="breadcrumbOverrides" />
    </ContentDiv>

    <LiteratureDescription type="book" :book="book" />
  </div>
</template>
